import React from 'react';
import { Box, Button } from '@mui/material';

/**
 * LoadMoreButton - A reusable atom component for incrementally loading items
 *
 * @param {Object} props
 * @param {number} props.remaining - How many items remain to load
 * @param {Function} props.onLoadMore - Callback to load more items
 * @param {Function} props.onShowAll - Callback to show all items (optional)
 * @param {string} props.label - Base label for the button (default: "Load More")
 * @param {Object} props.sx - Additional styling for the wrapper Box
 * @param {Object} props.buttonSx - Additional styling for the Button
 */
const LoadMoreButton = ({
  remaining = 0,
  onLoadMore,
  onShowAll,
  label = 'Load More',
  sx = {},
  buttonSx = {}
}) => {
  if (remaining <= 0) return null; // hide button if nothing to load

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 2, ...sx }}>
      <Button
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation();
          onLoadMore();
        }}
        sx={{
          borderRadius: '20px',
          textTransform: 'none',
          px: 3,
          ...buttonSx
        }}
      >
        {`${label} (${remaining})`}
      </Button>

      {onShowAll && (
        <Button
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            onShowAll();
          }}
          sx={{
            borderRadius: '20px',
            textTransform: 'none',
            px: 3,
            ...buttonSx
          }}
        >
          Show all
        </Button>
      )}
    </Box>
  );
};

export default LoadMoreButton;
